function normalizeNumber(value) {
  const parsed = Number(value)
  return Number.isFinite(parsed) ? parsed : 0
}

function normalizeLabel(value) {
  return typeof value === 'string' ? value.trim() : ''
}

function normalizeBooleanFlag(value) {
  return value === true || value === 1 || value === '1' || value === 'true'
}

function roundToTwo(value) {
  return Math.round((value + Number.EPSILON) * 100) / 100
}

export function canUseFractionedQuantity(unitSku, caixaComPesoVariavel = false) {
  return !normalizeBooleanFlag(caixaComPesoVariavel) && normalizeNumber(unitSku) > 0
}

export function resolveVolumeAndUnitsLabels({ unAgregadora, unFracionada } = {}) {
  const volumeLabel = normalizeLabel(unAgregadora) || 'Vol'
  const unitsLabel = normalizeLabel(unFracionada) || 'Uni'

  return { volumeLabel, unitsLabel }
}

export function calculateVolumeAndUnits(quantity, unitSku, caixaComPesoVariavel = false) {
  const normalizedQuantity = normalizeNumber(quantity)
  const normalizedUnitSku = normalizeNumber(unitSku)
  const isCaixaComPesoVariavel = normalizeBooleanFlag(caixaComPesoVariavel)

  if (isCaixaComPesoVariavel || normalizedUnitSku <= 0) {
    return { volume: roundToTwo(normalizedQuantity), units: 0 }
  }

  const sign = Math.sign(normalizedQuantity)
  const absoluteQuantity = Math.abs(normalizedQuantity)
  const integerPart = Math.floor(absoluteQuantity)
  const decimalPart = absoluteQuantity - integerPart

  return {
    volume: integerPart * sign,
    units: Math.round(decimalPart * normalizedUnitSku) * sign,
  }
}

export function sumVolumeAndUnits(items, getItemData) {
  return items.reduce(
    (total, item) => {
      const { quantity, unitSku, caixaComPesoVariavel } = getItemData(item)
      const { volume, units } = calculateVolumeAndUnits(
        quantity,
        unitSku,
        caixaComPesoVariavel,
      )

      return {
        volume: roundToTwo(total.volume + volume),
        units: total.units + units,
      }
    },
    { volume: 0, units: 0 },
  )
}

export function formatVolumeAndUnits({ volume, units, unAgregadora, unFracionada }) {
  const normalizedVolume = roundToTwo(volume)
  const volumeText = normalizedVolume === 0 && units < 0 ? '-0' : String(normalizedVolume)
  const { volumeLabel, unitsLabel } = resolveVolumeAndUnitsLabels({
    unAgregadora,
    unFracionada,
  })

  return `${volumeText} ${volumeLabel}, ${units} ${unitsLabel}`
}

export function formatQuantityToVolumeAndUnits({
  quantity,
  unitSku,
  caixaComPesoVariavel = false,
  unAgregadora,
  unFracionada,
}) {
  const calculated = calculateVolumeAndUnits(quantity, unitSku, caixaComPesoVariavel)

  return formatVolumeAndUnits({
    ...calculated,
    unAgregadora,
    unFracionada,
  })
}

export function convertVolumeAndUnitsToQuantity({
  volume,
  units,
  unitSku,
  caixaComPesoVariavel = false,
}) {
  const normalizedVolume = normalizeNumber(volume)
  const normalizedUnits = normalizeNumber(units)
  const normalizedUnitSku = normalizeNumber(unitSku)
  const isCaixaComPesoVariavel = normalizeBooleanFlag(caixaComPesoVariavel)

  if (isCaixaComPesoVariavel || normalizedUnitSku <= 0) {
    return roundToTwo(normalizedVolume)
  }

  return roundToTwo(normalizedVolume + normalizedUnits / normalizedUnitSku)
}
